export const NODES_ERROR_KEYS = {
  DELETE_START_NODE: 'delete_start_node',
};
